import { Row, Table } from 'react-bootstrap';
import Img from 'react-image';
import { getImageForFinanceSource } from '@upstart/harmony/lib/metadata';
import { FinanceProvider } from '@upstart/harmony/lib/constants';
import { fmtPercent, fmtPrice } from '@upstart/harmony/lib/formatter';
import React from 'react';
import { FinanceResponse } from '@upstart/harmony/lib/legos/financingTypes';
import { ValidateResponseResult } from '@upstart/harmony/lib/response-utils';

const OfferTable: React.FC<{
  response?: FinanceResponse;
  fetchingPayments: boolean;
  validations?: ValidateResponseResult;
}> = ({ response, fetchingPayments, validations }) => (
  <Table className="offer-table" data-testid="OfferTable">
    <thead>
      <tr>
        <th />
        <th>Amount</th>
        <th>APR</th>
        <th>Term</th>
      </tr>
    </thead>
    <tbody>
      <tr className="offer-line">
        <td>
          {response && (
            <Row>
              <Img
                className="finance-source-image"
                src={getImageForFinanceSource(FinanceProvider.UPSTART)}
                unloader={
                  <div className="finance-source-name">
                    {FinanceProvider.UPSTART}
                  </div>
                }
              />
            </Row>
          )}
        </td>
        {/* eslint-disable-next-line no-nested-ternary */}
        {fetchingPayments ? (
          <td className="loading-cell" colSpan={3}>
            Loading...
          </td>
        ) : validations?.isInvalid ? (
          <td className="loading-cell" colSpan={3}>
            N/A
          </td>
        ) : (
          <>
            <td className="amount">
              {fmtPrice(
                response?.data?.monthlyOverride ?? response?.data?.monthly ?? 0,
              )}
              /mo
            </td>
            <td>
              {fmtPercent(
                response?.data?.aprOverride ?? response?.data?.apr ?? 0,
              )}
            </td>
            <td>{response?.data?.months} Months</td>
          </>
        )}
      </tr>
    </tbody>
  </Table>
);

export default OfferTable;
